<template>
  <div
    class="layer-f"
    @mouseenter="TcActivate = true"
    @mouseleave="TcActivate = false"
  >
    <!-- <el-tooltip content="Bottom center" placement="bottom" effect="light"> -->
    <transition name="el-fade-in-linear">
      <div class="layer-pop" v-show="TcActivate">
        <el-tree
          ref="cascader"
          :data="dataList"
          show-checkbox
          node-key="id"
          :props="{
            label: 'layerName',
          }"
          :default-expand-all="true"
          :default-checked-keys="defaultChecked"
          @check="checkChangeLi"
          @check-change="checkChange"
        >
        </el-tree>
      </div>
    </transition>
    <!-- @click="TcActivate = !TcActivate" -->
    <div class="layer-box">
      <div class="layer-box-i">
        <img
          v-show="!TcActivate"
          class="imgStyle"
          src="../../assets/images/tc.png"
          alt=""
        />
        <img
          v-show="TcActivate"
          class="imgStyle"
          src="../../assets/images/tc-activate.png"
          alt=""
        />
        <!-- <i class="iconfont icon-tuceng"></i> -->
      </div>
      <div class="layer-box-t">
        <span style="display: block; color: #2c83f6" v-show="TcActivate"
          >图层</span
        >
        <span
          style="display: block; color: rgb(192, 196, 204)"
          v-show="!TcActivate"
          >图层</span
        >
      </div>
      <div class="layer-box-t">
        <i class="iconfont icon-xiala" style="color: rgb(192, 196, 204)"></i>
      </div>
    </div>
    <!-- </el-tooltip> -->
  </div>
</template>
<script>
import { fetchList } from "@/api/setting/layer.js";
import { getCountyChildShp, getQxShpByScope } from "@/api/setting/investment";
import Concert from "@/map/Convert";
import { cleanChartsOverlayId } from "@/pulgin/addChartOverlayPulgin";
export default {
  name: "layer",
  props: {
    mapView: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showTip: false,
      show: false,
      dataList: layerData,
      defaultChecked: [1, 2, 3],
      checkNode: [],
      TcActivate: false,
      obj: {
        530102: "", //	五华区
        530103: "", //	盘龙区
        530111: "", //	官渡区
        530112: "", //	西山区
        530113: "", //	东川区
        530121: "", //	呈贡区
        530122: "", //	晋宁区
        530124: "", //	富民县
        530125: "", //	宜良县
        530126: "", //	石林彝族自治县
        530127: "", //	嵩明县
        530128: "", //	禄劝彝族苗族自治县
        530129: "", //	寻甸回族彝族自治县
        530181: "", //	安宁市
        530302: "", //	麒麟区
        530321: "", //	马龙区
        530322: "", //	陆良县
        530323: "", //	师宗县
        530324: "", //	罗平县
        530325: "", //	富源县
        530326: "", //	会泽县
        530328: "", //	沾益区
        530381: "", //	宣威市
        530402: "", //	红塔区
        530421: "", //	江川区
        530422: "", //	澄江市
        530423: "", //	通海县
        530424: "", //	华宁县
        530425: "", //	易门县
        530426: "", //	峨山彝族自治县
        530427: "", //	新平彝族傣族自治县
        530428: "", //	元江哈尼族彝族傣族自治县
        530502: "", //	隆阳区
        530521: "", //	施甸县
        530522: "", //	腾冲市
        530523: "", //	龙陵县
        530524: "", //	昌宁县
        530602: "", //	昭阳区
        530621: "", //	鲁甸县
        530622: "", //	巧家县
        530623: "", //	盐津县
        530624: "", //	大关县
        530625: "", //	永善县
        530626: "", //	绥江县
        530627: "", //	镇雄县
        530628: "", //	彝良县
        530629: "", //	威信县
        530630: "", //	水富市
        530702: "", //	古城区
        530721: "", //	玉龙纳西族自治县
        530722: "", //	永胜县
        530723: "", //	华坪县
        530724: "", //	宁蒗彝族自治县
        530802: "", //	思茅区
        530821: "", //	宁洱哈尼族彝族自治县
        530822: "", //	墨江哈尼族自治县
        530823: "", //	景东彝族自治县
        530824: "", //	景谷傣族彝族自治县
        530825: "", //	镇沅彝族哈尼族拉祜族自治县
        530826: "", //	江城哈尼族彝族自治县
        530827: "", //	孟连傣族拉祜族佤族自治县
        530828: "", //	澜沧拉祜族自治县
        530829: "", //	西盟佤族自治县
        530902: "", //	临翔区
        530921: "", //	凤庆县
        530922: "", //	云县
        530923: "", //	永德县
        530924: "", //	镇康县
        530925: "", //	双江拉祜族佤族布朗族傣族自治县
        530926: "", //	耿马傣族佤族自治县
        530927: "", //	沧源佤族自治县
        532301: "", //	楚雄市
        532302: "", //	禄丰市
        532322: "", //	双柏县
        532323: "", //	牟定县
        532324: "", //	南华县
        532325: "", //	姚安县
        532326: "", //	大姚县
        532327: "", //	永仁县
        532328: "", //	元谋县
        532329: "", //	武定县
        532501: "", //	个旧市
        532502: "", //	开远市
        532522: "", //	蒙自市
        532523: "", //	屏边苗族自治县
        532524: "", //	建水县
        532525: "", //	石屏县
        532526: "", //	弥勒市
        532527: "", //	泸西县
        532528: "", //	元阳县
        532529: "", //	红河县
        532530: "", //	金平苗族瑶族傣族自治县
        532531: "", //	绿春县
        532532: "", //	河口瑶族自治县
        532601: "", //	文山市
        532622: "", //	砚山县
        532623: "", //	西畴县
        532624: "", //	麻栗坡县
        532625: "", //	马关县
        532626: "", //	丘北县
        532627: "", //	广南县
        532628: "", //	富宁县
        532801: "", //	景洪市
        532822: "", //	勐海县
        532823: "", //	勐腊县
        532901: "", //	大理市
        532922: "", //	漾濞彝族自治县
        532923: "", //	祥云县
        532924: "", //	宾川县
        532925: "", //	弥渡县
        532926: "", //	南涧彝族自治县
        532927: "", //	巍山彝族回族自治县
        532928: "", //	永平县
        532929: "", //	云龙县
        532930: "", //	洱源县
        532931: "", //	剑川县
        532932: "", //	鹤庆县
        533102: "", //	瑞丽市
        533103: "", //	芒市
        533122: "", //	梁河县
        533123: "", //	盈江县
        533124: "", //	陇川县
        533321: "", //	泸水市
        533323: "", //	福贡县
        533324: "", //	贡山独龙族怒族自治县
        533325: "", //	兰坪白族普米族自治县
        533421: "", //	香格里拉市
        533422: "", //	德钦县
        533423: "", //	维西傈僳族自治县
      },
    };
  },

  created() {
    this.concert = new Concert();
  },
  mounted() {
    //this.getList();
    this.getCountyLayer();
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     this.addMovedEvents();
    //   }, 1000);
    // });
  },
  methods: {
    getcolor() {
      let r = Math.floor(Math.random() * 256);
      let g = Math.floor(Math.random() * 256);
      let b = Math.floor(Math.random() * 256);
      return `rgb(${r},${g},${b})`;
    },
    addMovedEvents() {
      systemConfig.mapApi.addMoveendCallBack(() => {
        let zoomObj = systemConfig.mapApi.getZoomInfo();
        let level = Math.round(zoomObj.zoom);
        let index = this.defaultChecked.findIndex((item) => item == 3);

        if (level >= 10 && index != -1) {
          let data = systemConfig.mapApi.getViewExtent(); //获取视图范围
          let scope = [
            [data[0], data[3]],
            [data[2], data[3]],
            [data[2], data[1]],
            [data[0], data[1]],
            [data[0], data[3]],
          ];
          let obj = {
            scope: {
              type: "MultiPolygon",
              coordinates: [[scope]],
            },
          };
          getQxShpByScope(obj).then((res) => {
            if (res.data.success) {
              let countyShpList = res.data.data;
              systemConfig.mapApi.removeLayer("countyDistribution");
              let geojson = this.concert.toGeoJson(
                countyShpList,
                "geom",
                ["county", "id", "countyName", "lng", "lat"],
                4490
              );
              systemConfig.mapApi.addGeojsonMapLayer(
                geojson,
                "countyDistribution",
                layerData[2].layerIndex,
                0.7,
                undefined,
                undefined,
                (feature) => {
                  let properties = feature.getProperties();
                  let id = "county_" + properties.county;
                  feature.setProperties({ id: id });
                  let fillColor = xqjColorMatching[properties.county]; //填充色
                  return systemConfig.mapApi.setPolygonStyle(
                    properties.countyName,
                    "#5a6069",
                    fillColor,
                    "#fff",
                    "#fff"
                  );
                }
              );
            }
          });
        }
      });
    },
    //行政区划图层
    getCountyLayer() {
      getCountyChildShp({ county: "53" }).then((res) => {
        if (res.data.success) {
          let countyShpList = res.data.data;
          let geojson = this.concert.toGeoJson(
            countyShpList,
            "geom",
            ["county", "id", "countyName", "lng", "lat"],
            4490
          );
          systemConfig.mapApi.addGeojsonMapLayer(
            geojson,
            "countyDistribution",
            layerData[2].layerIndex,
            0.7,
            undefined,
            undefined,
            (feature) => {
              let properties = feature.getProperties();
              let id = "county_" + properties.county;
              feature.setProperties({ id: id });
              let fillColor = countyColorMatching[properties.county]; //填充色
              return systemConfig.mapApi.setPolygonStyle(
                properties.countyName,
                "#5a6069",
                fillColor,
                "#fff",
                "#fff"
              );
            }
          );
        }
      });
    },
    //获取图层列表
    async getList() {
      let { data: res } = await fetchList();
      if (res.success) {
        this.removeIsOpenFalse(res.data);
        this.dataList = res.data;
        this.addDeaultLayer(this.dataList);
      }
    },
    // 不展示删除数据中的禁用图层
    removeIsOpenFalse(data) {
      // 记录需要删除的下标
      let removeIndex;
      let d;
      for (let i in data) {
        d = data[i];
        if (!d.children) {
          // 是否有子节点
          if (!d.isOpen) {
            // 是否禁用
            removeIndex = i;
            break;
          }
        } else {
          this.removeIsOpenFalse(d.children); // 递归
        }
      }
      // 循环删除
      for (let i in removeIndex) {
        let index = parseInt(removeIndex[i]);
        data.splice(index, 1); // 由于 splice 删除数组后会改变原有的数组，
        this.removeIsOpenFalse(data); // 所以需要重新进行递归，判断剩下的是否还有需要删除的。
        //猜测，这个方式由于重新进行循环，在数据较大的情况下可能会有性能问题
      }
    },
    //递归添加默认图层
    addDeaultLayer(data) {
      if (data.length) {
        data.forEach((item) => {
          if (item.layerConfig && item.layerConfig.length) {
            let that = this;
            this.defaultChecked.forEach((changeItem) => {
              if (item.id == changeItem) {
                let code = `that.mapView.${item.methodCode}`;
                eval(code);

                //将默认数据添加进选中数据
                this.checkNode.push(item);
                this.$emit("callBackCheckNode", this.checkNode);
              } else {
                //没有找到符合条件的数据
              }
            });
          }
          //如果存在下级，继续调用方法
          if (item.children && item.children.length) {
            this.addDeaultLayer(item.children);
          }
        });
      }
    },
    /**
     * 取消勾选时，移除图层
     * data:当前节点数据
     * is_check:当前节点是都选中
     */
    checkChange(data, is_check) {
      if (is_check) {
        // 控制图层显隐
        data.layerId.forEach((item) => {
          systemConfig.mapApi.setLayerVisible(item, true);
        });
      } else {
        data.layerId.forEach((item) => {
          systemConfig.mapApi.setLayerVisible(item, false);
        });
        if (data.id == 1 && !is_check) {
          this.$eventBus.emit("removeCharts");
        }
        // if (data.id == 1) {
        //   for (var key in countyColorMatching) {
        //     let layerId = "echart_" + key;
        //     cleanChartsOverlayId(layerId);
        //   }
        // }
      }
      let index = this.dataList.findIndex((item) => item.id == data.id);
      this.dataList[index].isShow = is_check;
      layerData = this.dataList;
      if (data.id != 3) {
        let val = data.id == 1 ? true : false;
      }
      //图层选中监听
      this.$eventBus.emit("layerChange");
      if (data.id == 3 && is_check) {
        isRenderingXzqh = true;
      }
      if (data.id == 3 && !is_check) {
        isRenderingXzqh = false;
      }
      let len = this.$refs["cascader"].getCheckedNodes();
      this.TcActivate = len.length ? true : false;
      //节点未选中且data.layerConfig不为空时执行
      // if (!is_check && data.layerConfig) {
      //   let index = data.layerConfig.findIndex(
      //     (item) => item.filed == "layerId"
      //   );
      //   this.mapView.removeLayer(data.layerConfig[index].value);

      //   let delIndex = this.checkNode.findIndex((item) => item.id == data.id);
      //   this.checkNode.splice(delIndex, 1);
      // }
      // if (is_check && data.layerConfig) {
      //   this.checkNode.push(data);
      // }
      // this.$emit("callBackCheckNode", this.checkNode);
    },
    checkChangeLi(cancelArr, data) {
      // if (data.checkedNodes.length) {
      //   let that = this;
      //   data.checkedNodes.forEach((item) => {
      //     if (item.layerConfig) {
      //       let code = `that.mapView.${item.methodCode}`;
      //       eval(code);
      //     }
      //   });
      // }
      // if (data.checkedKeys.length == 0) {
      //   this.TcActivate = false;
      // } else {
      //   this.TcActivate = true;
      // }
    },
  },
};
</script>
<style scoped>
.layer-pop::after {
  position: absolute;
  display: inline-block;
  top: -4px;
  left: calc(50% - 4px);
  width: 0px;
  height: 0px;
  content: "";
  border-style: solid;
  border-width: 4px;
  border-color: #fff #fff transparent transparent;
  transform: rotate(-45deg);
  box-shadow: 2px -2px 2px rgba(0, 0, 0, 0.1);
}
.layer-f {
  position: relative;
  height: 32px;
}

.layer-box {
  /* width: 80px; */
  height: 30px !important;
  /* padding: 2px 5px; */
  text-align: center;
  color: #837e7e;
  background: #fff;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
}

.layer-box-i > i {
  color: #0657b4;
  font-size: 18px;
}

.layer-box-t {
  font-size: 13px;
  margin-left: 4px;
}

.layer-pop {
  /* position: absolute;
  top: 41px;
  right: 0px; */
  position: absolute;
  top: 45px;
  left: -20px;
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  color: #837e7e;
      box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1);
  /* border: 1px solid #c9c9c9; */
  /* box-shadow: #d9d8d8 0px 1px 2px 2px; */
  /* border-radius: 4px; */
  /* padding: 10px; */
  /* z-index: 1; */
}

>>> .el-tree-node__content:hover,
>>> .el-upload-list__item:hover {
  background-color: #0a6d7c85;
  color: #0cd7f5;
}

>>> .layer-pop .el-tree {
  background: none;
  color: #837e7e;
}

>>> .el-tree-node__content {
  background: none !important;
}

/* .el-tree-node__content > .el-tree-node__expand-icon {
  padding: 0;
} */
.el-tooltip__popper.is-light {
  border: none;
}

/* .layer-pop::before {
  content: "";
  width: 0;
  height: 0;
  border: 8px solid;
  position: absolute;
  top: -16px;
  right: 26px;
  border-color: transparent transparent #fff transparent;
} */
.imgStyle {
  width: 14px;
}

.layer-pop-t {
  padding: 8px 0;
  font-size: 13px;
  cursor: pointer;
}

.layer-pop-t:hover {
  color: #0cd7f5;
}

.active-i {
  color: #0cd7f5;
}

::v-deep .layer-f .el-tooltip__popper.is-light {
  border: none;
}
</style>
